import React from "react";
import { Link } from "react-router-dom";

/**
 * ListingCard — tall portrait editorial card with a Reserve Now CTA.
 * variant: 'tall' (3/4 portrait), 'wide' (16/9)
 */
export default function ListingCard({ listing, index = 0, variant = "tall" }) {
  const aspect = variant === "wide" ? "aspect-[16/10]" : "aspect-[3/4]";
  return (
    <div className="group relative" data-testid={`listing-card-${listing.slug}`}>
      <Link to={`/listing/${listing.slug}`} className="block" data-testid={`listing-card-link-${listing.slug}`}>
        <div className={`relative overflow-hidden ${aspect} bg-[var(--ml-surface)] border border-white/5`}>
          <img
            src={listing.hero_image}
            alt={listing.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover moody-img"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
          <div className="absolute top-5 left-5 right-5 flex items-start justify-between">
            <span className="overline">№ {String(index + 1).padStart(2, "0")}</span>
            {listing.featured && (
              <span className="text-[0.6rem] tracking-[0.28em] uppercase text-[var(--ml-gold)] border border-[var(--ml-gold)]/40 px-2 py-1">
                Featured
              </span>
            )}
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7 pr-24 md:pr-28">
            <p className="text-[0.65rem] uppercase tracking-[0.25em] text-[var(--ml-text-dim)] mb-2">
              {listing.location}
            </p>
            <h3 className="font-serif-ml text-3xl md:text-4xl leading-[0.95] tracking-tight text-[var(--ml-text)] mb-3">
              {listing.name}
            </h3>
            <p className="text-sm text-[var(--ml-text-dim)] leading-snug line-clamp-2 max-w-sm">
              {listing.tagline}
            </p>
          </div>
        </div>
      </Link>

      <a
        href="https://booking.travelchannelworld.com/en/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`listing-card-reserve-${listing.slug}`}
        onClick={(e) => e.stopPropagation()}
        className="absolute bottom-5 right-5 bg-[var(--ml-gold)] hover:bg-white text-black px-4 py-2.5 text-[0.6rem] uppercase tracking-[0.22em] font-semibold transition-colors z-10"
      >
        Reserve Now
      </a>
    </div>
  );
}
